
const ErrorMessage = ({error}) => (
    error && <p>{error.toString()}</p>
);

export default ErrorMessage;
